import React, {useState} from 'react';
import {TabItem as TabItemType} from "../../types";
import {root, rootSelected, text, topBar, topBarSelected} from "./styles";
import { useHistory } from 'react-router-dom';

export interface TabItemProps {
    option: TabItemType;
    selected?: boolean;
    onClick?(target: TabItemType): void;
}





export const TabItem: React.FC<TabItemProps> = ({
    option,
    onClick,
    selected
}) => {

    const history = useHistory();

    const handleClick = (name: string) => {

        if(window.location.pathname == "/"){
            if (option.label !== "PM10")
                history.push("/air-quality-monitoring/calibrations");
        }else {
            if (window.location.pathname == "/air-quality-monitoring/") {
                if (option.label !== "PM10")
                    history.push(name.toLowerCase());
            } else {
                if (window.location.pathname == "/air-quality-monitoring/calibrations") {
                    if (name == "PM10")
                        history.push("/air-quality-monitoring/");
                }
            }
        }
    }

    return(
    <button css={[root, selected && rootSelected]} onClick={() => {
            handleClick(option.label)
        // if(onClick) {
        //     console.log('click')
        //     onClick(option);
        // }
    }}>
        <div css={[topBar, selected && topBarSelected]} />
        <span css={text}>{option.label}</span>
    </button>)
};